import {ApiEndPoints, HttpMethods} from "../base/Settings";
import type {ChatRequest, FetchRequest, UUID} from "../base/ui_general/GeneralInterfaces";


/**
 * Creates a FetchRequest for posting a chat prompt to the backend. The backend responds as a streaming response.
 * This request encodes prompt and optional transaction_id as query parameters.
 *
 * @param chat_request The user's chat prompt
 */
export function getRequest_post_chat(chat_request: ChatRequest): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.CHAT,
        method: HttpMethods.POST,
        query_parameters: {},
        body: chat_request,
    };
}


/**
 * Creates a FetchRequest for loading the chat history for the current user/thread.
 * Encodes optional transaction_id as a query parameter, as per backend signature.
 *
 * @param transaction_id Optional transaction id to scope the chat thread history
 */
export function getRequest_get_chat(transaction_id?: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.CHAT,
        method: HttpMethods.GET,
        query_parameters: transaction_id ? { transaction_id } : {},
    };
}
